"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _request = _interopRequireDefault(require("../../request"));
// 业务系统配置模块
var _default = exports.default = {
  getList: function getList(data, cancelToken) {
    return (0, _request.default)({
      // url: '/protected/role/list',
      url: '/protected/sfeRole/list',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  getDetail: function getDetail(id) {
    return (0, _request.default)({
      url: '/protected/role/query/' + id,
      method: 'get'
    });
  },
  saveItem: function saveItem(data) {
    return (0, _request.default)({
      url: '/protected/role/save',
      method: 'post',
      data: data
    });
  },
  deleteItem: function deleteItem(data) {
    return (0, _request.default)({
      module: 'CORE',
      // url: '/protected/role/delete',
      url: '/protected/sfeRole/delete',
      method: 'post',
      data: data
    });
  },
  enableItem: function enableItem(id) {
    return (0, _request.default)({
      url: '/protected/role/enable/' + id,
      method: 'get'
    });
  },
  disabledItem: function disabledItem(id) {
    return (0, _request.default)({
      url: '/protected/role/disable/' + id,
      method: 'get'
    });
  },
  rolePermissionDetail: function rolePermissionDetail(id) {
    return (0, _request.default)({
      url: '/protected/role/rolePermissions/' + id,
      method: 'get'
    });
  },
  rolePermissionSave: function rolePermissionSave(data) {
    return (0, _request.default)({
      url: '/protected/role/rolePermissions/save',
      method: 'post',
      data: data
    });
  },
  roleInfoDetail: function roleInfoDetail(id) {
    return (0, _request.default)({
      url: '/protected/role/userRoles/' + id,
      method: 'get'
    });
  },
  roleInfoSave: function roleInfoSave(data) {
    return (0, _request.default)({
      url: '/protected/role/userRoles/save',
      method: 'post',
      data: data
    });
  }
};